var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-btn-scroll-to-top",on:{"click":function($event){_vm.handleScrollToTop()}}},[_c('i',{staticClass:"fa fa-chevron-up"}),_vm._v(" "),_c('div',[_vm._v("TOP")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a89d02b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButtonScrollToTop.vue
// module id = null
// module chunks = 